import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { FileText } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

export const DocumentParserNode = memo(({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data?.label || 'Document Parser'}
        icon={FileText}
        colorClass="from-orange-500 to-orange-700"
        bgClass="bg-gradient-to-br from-orange-500 to-orange-700"
        selected={selected}
        isRunning={data?.executionStatus === 'Running'}
        executionStatus={data?.executionStatus}
        isSource={true}
        isTarget={true}
        threeSidedHandles={true}
        rowsProcessed={data?.rowsAffected}
    />
));
DocumentParserNode.displayName = 'DocumentParserNode';
export default DocumentParserNode;
